module.exports = __webpack_public_path__ + "img/icon_2_39.bbcc31d7.png";